import { useContext } from "react";
import constants from "../../constants";
import useAxiosPrivate from "../useAxiosPrivate";
import AlertContext from "../../context/AlertContext";
import useCommonFunctionHooks from "../useCommonFunctionHooks";
import { getDataFromStorage } from "../../util";
import StudentTestPageCalcStatsHooks from "./StudentTestPageCalcStatsHooks";
import { StudentTestPageContext } from "../../context/StudentTestPageContext";
import { streamToUint8Array } from "../../Components/CommonComponents/PdfViewer";
import StudentTestPageQuestionUpdateHooks from "./StudentTestPageQuestionUpdateHooks";
import CodingTestHooks from "../CodingPage/CodingTestHooks";
import useS3FileManagement from "../useS3FileManagement";
import * as axiosPublic from "../../api/axios";
import CreateSchemaTableHooks from "../CreateSchemaTableHooks";
import NotifyBody from "../../Components/Notify/NotifyBody";

export default function StudentTestPageHooks() {
  const Alert = useContext(AlertContext);
  const StudentTestPageCxt = useContext(StudentTestPageContext);

  const axios = useAxiosPrivate();
  const { updateStatus } = CodingTestHooks();
  const { calcStats } = StudentTestPageCalcStatsHooks();
  const { questionUpdate } = StudentTestPageQuestionUpdateHooks();

  const {handleRegistration, getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();
  const { getPreSignedUrl, getS3Object } = useS3FileManagement();

  const { parseCreateTable } = CreateSchemaTableHooks();

  let tempReport,
    tempTestData,
    answerObject = {},
    tempScoresObj = {},
    pendingRequestController = null;

  const checkIfObjectExistsInArray = (obj, array) => {
    for (let i = 0; i < array.length; i++) {
      if (JSON.stringify(obj) === JSON.stringify(array[i])) {
        return true;
      }
    }

    return false;
  };

  const handleScoreKeyDown = (e) => {
    if (e.keyCode === "38") {
      e.target.blur();
      e.preventDefault();
    } else if (e.keyCode === "40") {
      e.target.blur();
      e.preventDefault();
    }
  };

  const traverseInitialize = () => {
    Alert.setPrevButton(false);
    Alert.setNextButton(false);

    if (Alert.queLen > 1 || Alert.secLen > 1) {
      Alert.setNextButton(true);
    }
  };

  const getSectionTotal = (section) => {
    let total = 0;

    for (let i = 0; i < section.questions.length; i++) {
      total = total + section.questions[i].targetscore;
    }

    return total;
  };

  const preventCopyAndCut = (event) => {
    if (
      !Alert.isAdmin &&
      (event.key === "PrintScreen" ||
        ((event.ctrlKey || event.metaKey) &&
          (event.key === "c" ||
            event.key === "x" ||
            event.key === "v" ||
            event.key === "PrintScreen")))
    ) {
      navigator.clipboard.writeText("");
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const assignQuestionIds = (dataArr, sections1) => {
    return dataArr.map((section) => {
      const currentSection = {
        secName: section.secName,
        secId: section.secId,
        qnsObj: { ...section.qnsObj },
      };

      const relevantSection = sections1.find(
        (s) => s.sectionid === section.secId,
      );
      if (relevantSection) {
        Object.keys(currentSection.qnsObj).forEach((key, index) => {
          const obj = currentSection.qnsObj[key];
          const matchedQuestion = relevantSection.questions[index];

          if (matchedQuestion) {
            obj.qId = matchedQuestion.id;
          }
        });
      }

      return currentSection;
    });
  };

  const handleVideoQuestions = (dataOfSections) => {
    let mArr = [];
    let questionIndex = 0;

    dataOfSections.map((item, ind) => {
      let cc = 1;
      let MqObj = {
        qnsObj: {},
        secId: item.sectionid,
        secName: item.sectionname,
      };

      item.qnconfig.map((i) => {
        for (let j = 0; j < i.qncount + i.fixedqncount; j++) {
          let qObj = {};

          qObj.qId = item.questions[questionIndex]
            ? item.questions[questionIndex].id
            : "";
          qObj.isAnswered =
            item.questions[questionIndex] &&
            item.questions[questionIndex].answer &&
            item.questions[questionIndex].answer !== ""
              ? true
              : false;
          qObj.qnduration = i.qnduration / (i.qncount + i.fixedqncount);
          qObj.marks = i.marks;
          qObj.complexityId = i.complexityid;
          qObj.topicId = i.topicid;

          if (
            item.questions[questionIndex] &&
            item.questions[questionIndex].answer &&
            item.questions[questionIndex].answer !== ""
          ) {
            qObj.answer = item.questions[questionIndex].answer;
          }

          MqObj.qnsObj[cc] = qObj;
          cc++;
          questionIndex++;
        }

        return "";
      });

      mArr.push(MqObj);

      return "";
    });

    let videoQuestionsObj = assignQuestionIds(mArr, dataOfSections);

    Alert.questionListObj.current = videoQuestionsObj;
    Alert.sectionWithQuestions.current = dataOfSections;
  };

  const resetTest = () => {
    // handling practice retake

    axios
      .post(
        "/node/learner/course/test/reset",
        JSON.stringify({
          testid: Alert.testData.testid,
          lpconfigid: Alert.testData.lpconfigid,
          learnerid: getDataFromStorage("learnerid"),
        }),
        getHeaderDetailsForAxios(),
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          startTest("reset");
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
        Alert.setButtonDisable(false);
      });
  };

  const startTest = (from) => {
    Alert.PractSingleQnAns.current = false;

    if (pendingRequestController) {
      pendingRequestController.abort(); // Cancel previous request
    }
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    }

    pendingRequestController = new AbortController(); // Create new controller

    const signal = pendingRequestController.signal;

    if (from === "reset") {
      Alert.setStatus(constants.PROGRESS_STATUS.QN_CONTINUE);
    }

    Alert.setLpConfigId(Alert.testData.lpconfigid);
    Alert.setMcqAndDesTestAndLpId({
      lpid: Alert.lpId,
      testid: Alert.testData.testid,
      cellobj: Alert.testData.libtype,
      autoEval: Alert.testData.autoeval,
      testmode: Alert.testData.testmode,
      viewTest: Alert.testData.viewTest,
      libtypeid: Alert.testData.testtype,
      proctored: Alert.testData.proctored,
      configdata: Alert.testData.configdata,
      lpconfigid: Alert.testData.lpconfigid,
      learnerid: getDataFromStorage("learnerid"),
      status:
        from === "reset" ? constants.PROGRESS_STATUS.QN_CONTINUE : Alert.status,
    });

    Alert.setTestPageShow(true);
    Alert.setTakeMcqAndDesTest(true);

    const payload = JSON.stringify({
      lpid: Alert.lpId,
      isTakingTest: true,
      lmpid: Alert.testData.lmpid,
      testid: Alert.testData.testid,
      mockuse: Alert.testData.mockuse,
      withAI: Alert.testData.ainterview,
      libtypeid: Alert.testData.testtype,
      lpconfigid: Alert.testData.lpconfigid,
      mocklp: localStorage.getItem("mockLp"),
      learnerid: getDataFromStorage("learnerid"),
    });

    const apiEndpoint =
      from === "reset" ||
      from === "practiceRetake" ||
      Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
        ? "node/learner/course/test/report"
        : "node/learner/course/test/get";

    const handleResponse = async (res) => {
      try {
        if(res.data.resultCode  === constants.RESULT_STATUS.FACE_NOT_REGISTERED){
          Alert.setShowNotify({
            show: true,
            size: "lg",
            primaryButton: "Continue",
            secondaryButton: "Cancel",
            primaryButtonFunction: handleRegistration,
            title: "First time taking a proctored test.",
            msg: <NotifyBody component="instructionPageNotifyMsgForRegistration" />,
          });
          return
        } else if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.msg || res.data.message,
          });

          return;
        }

        tempTestData = res.data.data;

        if (tempTestData.videoqn) {
          handleVideoQuestions(tempTestData.sections);
        }

        for (let i = 0; i < tempTestData.sections.length; i++) {
          for (let j = 0; j < tempTestData.sections[i].questions.length; j++) {
            let q = tempTestData.sections[i].questions[j];

            if (Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) {
              q.review = -1;

              if (q.answer === "" || q.answer == null) {
                q.choosed = q.answered = -1;
                q.visited = q.previsited = i === 0 && j === 0 ? "this" : "new";
                q.review = -1;
              } else {
                q.visited = q.previsited = "completed";
                q.answered = 0;
              }

              answerObject = { ...answerObject, [q.id]: q.answer };
            } else {
              q.choosed = q.answered = -1;
              q.visited = q.previsited = i === 0 && j === 0 ? "this" : "new";
              q.review = -1;

              answerObject = { ...answerObject, [q.id]: "" };
            }

            if (process.env.REACT_APP_DEPLOYMENT === "AWS" && q.links?.length) {
              for (let k = 0; k < q.links.length; k++) {
                let linkRes = await getPreSignedUrl(
                  q.links[k].link,
                  undefined,
                  q.links[k].link?.split(".")?.pop(),
                  "GET",
                );

                q.links[k].link = linkRes.url;
              }
            }
          }
        }

        Alert.answerRef.current = answerObject;
        Alert.setMcqTestData(tempTestData);
        Alert.updateComingObj(tempTestData);
        questionUpdate(0, 0, tempTestData);
        Alert.updateQuestionContainerSingle(true);
        traverseInitialize();
        Alert.setTestMode(tempTestData.testmode);
        Alert.duration.current = tempTestData?.timeleft
          ? tempTestData?.timeleft
          : tempTestData?.duration;
        if (
          Alert.testData.testmode === constants.MODE.TEST_MODE &&
          (Alert.testData.proctored === constants.PROCTORING_MODE.DUAL ||
            Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM ||
            Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC)
        ) {
          if (Alert.testData.proctored === constants.PROCTORING_MODE.DUAL) {
            updateStatus({
              status: 2,
              testId: Alert.testData.testid,
              duration: Alert.duration.current,
            });
          }

          Alert.setIsTakeTest(true);
        }

        //  --- NEW: prepare testDetail when SQL so /sql has what it needs immediately ---
        if (Alert.testData.testtype === constants.libTypeIds.SQL) {
          res.data.data.sections[0].questions =
            res.data.data.sections[0]?.questions.map(
              ({ answer, ...rest }, _, arr) => ({
                ...rest,
                solution: answer,
              }),
            );

          Alert.setTestDetail(() => ({
            currentIndex: 0,
            data: tempTestData,
            totalQn: tempTestData.sections?.[0]?.questions?.length || 0,
            ...(tempTestData.sections?.[0]?.questions?.[0] || {}),
            schema: parseCreateTable(
              tempTestData.sections?.[0]?.questions?.[0]?.dbSchema,
            ),
            language: [{ value: 1, label: "SQL" }],
            selectedLanguage: { value: 1, label: "SQL" },
          }));
        }

        if (Alert.testData.ainterview) {
          Alert.navigate("/ainterview");
        } else if (Alert.testData.testtype === constants.libTypeIds.SQL) {
          Alert.navigate("/sql");
        } else {
          Alert.navigate("/mcq");
        }
      } catch (err) {
        getCatchBlockDetails(err);
      } finally {
        Alert.setIsLoaded(false);
        Alert.setButtonDisable(false);
      }
    };

    if (
      from === "reset" ||
      from === "practiceRetake" ||
      Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
      Alert.status === constants.PROGRESS_STATUS.REATTEMPT ||
      Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
      Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
    ) {
      Alert.setIsLoaded(true);
      Alert.setButtonDisable(true);

      axios
        .post(apiEndpoint, payload, {
          ...getHeaderDetailsForAxios(),
          signal,
        })
        .then(handleResponse)
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.warn("Previous request canceled");
          } else {
            getCatchBlockDetails(error);
          }
        })
        .finally(() => {
          Alert.setIsLoaded(false);
          Alert.setButtonDisable(false);
        });
    }
  };

  // const startTest = (from) => {
  //   Alert.PractSingleQnAns.current = false;

  //   if (from === "reset") {
  //     // handling practice retake

  //     Alert.setStatus(constants.PROGRESS_STATUS.REATTEMPT);
  //   }

  //   Alert.setLpConfigId(Alert.testData.lpconfigid);
  //   Alert.setMcqAndDesTestAndLpId({
  //     lpid: Alert.lpId,
  //     testid: Alert.testData.testid,
  //     cellobj: Alert.testData.libtype,
  //     autoEval: Alert.testData.autoeval,
  //     testmode: Alert.testData.testmode,
  //     viewTest: Alert.testData.viewTest,
  //     libtypeid: Alert.testData.testtype,
  //     proctored: Alert.testData.proctored,
  //     configdata: Alert.testData.configdata,
  //     lpconfigid: Alert.testData.lpconfigid,
  //     learnerid: getDataFromStorage("learnerid"),
  //     status:
  //       from === "reset" ? constants.PROGRESS_STATUS.REATTEMPT : Alert.status, // handling practice retake
  //   });

  //   Alert.setTestPageShow(true);
  //   Alert.setTakeMcqAndDesTest(true);

  //   if (
  //     from === "reset" || // handling practice retake
  //     Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
  //     Alert.status === constants.PROGRESS_STATUS.REATTEMPT
  //   ) {
  //     Alert.setIsLoaded(true);
  //     Alert.setButtonDisable(true);
  //     axios
  //       .post(
  //         "node/learner/course/test/get",
  //         JSON.stringify({
  //           lpid: Alert.lpId,
  //           isTakingTest: true,
  //           lmpid: Alert.testData.lmpid,
  //           testid: Alert.testData.testid,
  //           mockuse: Alert.testData.mockuse,
  //           withAI: Alert.testData.ainterview,
  //           libtypeid: Alert.testData.testtype,
  //           lpconfigid: Alert.testData.lpconfigid,
  //           mocklp: localStorage.getItem("mockLp"),
  //           learnerid: getDataFromStorage("learnerid"),
  //         }),
  //         getHeaderDetailsForAxios()
  //       )
  //       .then((res) => {
  //         (async () => {
  //           try {
  //             Alert.setResultCode(res.data.resultCode);

  //             if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
  //               Alert.setShowNotify({
  //                 show: true,
  //                 title: "Info",
  //                 msg: res.data.msg,
  //               });
  //             } else {
  //               tempTestData = res.data.data;

  //               if (tempTestData.videoqn) {
  //                 handleVideoQuestions(tempTestData.sections);
  //               }

  //               for (let i = 0; i < tempTestData.sections.length; i++) {
  //                 for (
  //                   let j = 0;
  //                   j < tempTestData.sections[i].questions.length;
  //                   j++
  //                 ) {
  //                   if (
  //                     Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
  //                   ) {
  //                     if (
  //                       tempTestData.sections[i].questions[j].answer === "" ||
  //                       tempTestData.sections[i].questions[j].answer === null ||
  //                       tempTestData.sections[i].questions[j].answer ===
  //                         undefined
  //                     ) {
  //                       tempTestData.sections[i].questions[j].choosed = -1;
  //                       tempTestData.sections[i].questions[j].answered = -1;
  //                       tempTestData.sections[i].questions[j].visited =
  //                         i === 0 && j === 0 ? "this" : "new";
  //                       tempTestData.sections[i].questions[j].review = -1;
  //                       tempTestData.sections[i].questions[j].previsited =
  //                         i === 0 && j === 0 ? "this" : "new";
  //                     } else {
  //                       tempTestData.sections[i].questions[j].visited =
  //                         "completed";
  //                       tempTestData.sections[i].questions[j].previsited =
  //                         "completed";
  //                       tempTestData.sections[i].questions[j].answered = 0;
  //                     }

  //                     answerObject = {
  //                       ...answerObject,
  //                       [tempTestData.sections[i].questions[j].id]:
  //                         tempTestData.sections[i].questions[j].answer,
  //                     };
  //                   } else {
  //                     tempTestData.sections[i].questions[j].choosed = -1;
  //                     tempTestData.sections[i].questions[j].answered = -1;
  //                     tempTestData.sections[i].questions[j].visited =
  //                       i === 0 && j === 0 ? "this" : "new";
  //                     tempTestData.sections[i].questions[j].review = -1;
  //                     tempTestData.sections[i].questions[j].previsited =
  //                       i === 0 && j === 0 ? "this" : "new";

  //                     answerObject = {
  //                       ...answerObject,
  //                       [tempTestData.sections[i].questions[j].id]: "",
  //                     };
  //                   }

  //                   if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
  //                     let question = tempTestData.sections[i].questions[j];

  //                     for (let k = 0; k < question.links.length; k++) {
  //                       let linkRes = await getPreSignedUrl(
  //                         question.links[k].link
  //                       );

  //                       question.links[k].link = linkRes;
  //                     }
  //                   }
  //                 }
  //               }

  //               // Alert.setAnswers(answerObject);
  //               Alert.answerRef.current = answerObject;
  //               Alert.setMcqTestData(tempTestData);
  //               Alert.updateComingObj(tempTestData);
  //               questionUpdate(0, 0, tempTestData);
  //               Alert.updateQuestionContainerSingle(true);
  //               traverseInitialize();
  //               Alert.setTestMode(res.data.data.testmode);
  //               Alert.duration.current = tempTestData.duration;

  //               if (
  //                 (Alert.testData.proctored ===
  //                   constants.PROCTORING_MODE.DUAL ||
  //                   Alert.testData.proctored ===
  //                     constants.PROCTORING_MODE.TAB_CAM) &&
  //                 Alert.testData.testmode === constants.MODE.TEST_MODE
  //               ) {
  //                 if (
  //                   Alert.testData.proctored === constants.PROCTORING_MODE.DUAL
  //                 ) {
  //                   updateStatus({
  //                     status: 2,
  //                     testId: Alert.testData.testid,
  //                     duration: tempTestData.duration,
  //                   });
  //                 }

  //                 Alert.setIsTakeTest(true);
  //               }

  //               if (Alert.testData.ainterview) {
  //                 Alert.navigate("/ainterview");
  //               } else {
  //                 Alert.navigate("/mcq");
  //               }
  //             }
  //           } catch (err) {
  //             getCatchBlockDetails(err);
  //           } finally {
  //             Alert.setIsLoaded(false);
  //             Alert.setButtonDisable(false);
  //           }
  //         })();
  //       })
  //       .catch((error) => {
  //         getCatchBlockDetails(error);
  //       })
  //       .finally(() => {
  //         Alert.setIsLoaded(false);
  //         Alert.setButtonDisable(false);
  //       });
  //   }

  //   if (
  //     from === "practiceRetake" ||
  //     Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
  //   ) {
  //     Alert.hasRendered.current = true;
  //     Alert.setIsLoaded(true);
  //     Alert.setButtonDisable(true);
  //     axios
  //       .post(
  //         "node/learner/course/test/report",
  //         JSON.stringify({
  //           lpid: Alert.lpId,
  //           isTakingTest: true,
  //           lmpid: Alert.testData.lmpid,
  //           testid: Alert.testData.testid,
  //           mockuse: Alert.testData.mockuse,
  //           libtypeid: Alert.testData.testtype,
  //           lpconfigid: Alert.testData.lpconfigid,
  //           mocklp: localStorage.getItem("mockLp"),
  //           learnerid: getDataFromStorage("learnerid"),
  //         }),
  //         getHeaderDetailsForAxios()
  //       )
  //       .then((res) => {
  //         Alert.hasRendered.current = false;
  //         Alert.backupTestDataq.current = res.data.data;

  //         (async () => {
  //           try {
  //             if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
  //               Alert.setShowNotify({
  //                 show: true,
  //                 title: "Info",
  //                 msg: res.data.message,
  //               });
  //             } else {
  //               tempTestData = res.data.data;

  //               if (tempTestData.videoqn) {
  //                 handleVideoQuestions(tempTestData.sections);
  //               }

  //               for (let i = 0; i < tempTestData.sections.length; i++) {
  //                 for (
  //                   let j = 0;
  //                   j < tempTestData.sections[i].questions.length;
  //                   j++
  //                 ) {
  //                   if (
  //                     Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
  //                   ) {
  //                     tempTestData.sections[i].questions[j].review = -1;

  //                     if (
  //                       tempTestData.sections[i].questions[j].answer === "" ||
  //                       tempTestData.sections[i].questions[j].answer === null ||
  //                       tempTestData.sections[i].questions[j].answer ===
  //                         undefined
  //                     ) {
  //                       tempTestData.sections[i].questions[j].choosed = -1;
  //                       tempTestData.sections[i].questions[j].answered = -1;
  //                       tempTestData.sections[i].questions[j].visited =
  //                         i === 0 && j === 0 ? "this" : "new";
  //                       tempTestData.sections[i].questions[j].review = -1;
  //                       tempTestData.sections[i].questions[j].previsited =
  //                         i === 0 && j === 0 ? "this" : "new";
  //                     } else {
  //                       tempTestData.sections[i].questions[j].visited =
  //                         "completed";
  //                       tempTestData.sections[i].questions[j].previsited =
  //                         "completed";
  //                       tempTestData.sections[i].questions[j].answered = 0;
  //                     }

  //                     answerObject = {
  //                       ...answerObject,
  //                       [tempTestData.sections[i].questions[j].id]:
  //                         tempTestData.sections[i].questions[j].answer,
  //                     };
  //                   } else {
  //                     tempTestData.sections[i].questions[j].choosed = -1;
  //                     tempTestData.sections[i].questions[j].answered = -1;
  //                     tempTestData.sections[i].questions[j].visited =
  //                       i === 0 && j === 0 ? "this" : "new";
  //                     tempTestData.sections[i].questions[j].review = -1;
  //                     tempTestData.sections[i].questions[j].previsited =
  //                       i === 0 && j === 0 ? "this" : "new";

  //                     answerObject = {
  //                       ...answerObject,
  //                       [tempTestData.sections[i].questions[j].id]: "",
  //                     };
  //                   }

  //                   if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
  //                     let question = tempTestData.sections[i].questions[j];

  //                     for (let k = 0; k < question.links.length; k++) {
  //                       let linkRes = await getPreSignedUrl(
  //                         question.links[k].link
  //                       );

  //                       question.links[k].link = linkRes;
  //                     }
  //                   }
  //                 }
  //               }

  //               // Alert.setAnswers(answerObject);
  //               Alert.answerRef.current = answerObject;
  //               Alert.setMcqTestData(tempTestData);
  //               Alert.updateComingObj(tempTestData);
  //               questionUpdate(0, 0, tempTestData);
  //               Alert.updateQuestionContainerSingle(true);
  //               traverseInitialize();
  //               Alert.setTestMode(res.data.data.testmode);
  //               Alert.duration.current = tempTestData.timeleft;

  //               if (
  //                 (Alert.testData.proctored ===
  //                   constants.PROCTORING_MODE.DUAL ||
  //                   Alert.testData.proctored ===
  //                     constants.PROCTORING_MODE.TAB_CAM) &&
  //                 Alert.testData.testmode === constants.MODE.TEST_MODE
  //               ) {
  //                 if (
  //                   Alert.testData.proctored === constants.PROCTORING_MODE.DUAL
  //                 ) {
  //                   updateStatus({
  //                     status: 2,
  //                     testId: Alert.testData.testid,
  //                     duration: tempTestData.timeleft,
  //                   });
  //                 }

  //                 Alert.setIsTakeTest(true);
  //               }

  //               Alert.navigate("/mcq");
  //             }
  //           } catch (err) {
  //             getCatchBlockDetails(err);
  //           } finally {
  //             Alert.setIsLoaded(false);
  //             Alert.setButtonDisable(false);
  //           }
  //         })();
  //       })
  //       .catch((error) => {
  //         getCatchBlockDetails(error);
  //       })
  //       .finally(() => {
  //         Alert.setIsLoaded(false);
  //         Alert.setButtonDisable(false);
  //       });
  //   }
  // };

  const fetchVideoData = async (path) => {
    try {
      let url;

      if (process.env.REACT_APP_DEPLOYMENT === "LOCAL") {
        url = { url: process.env.REACT_APP_NODE_API + path };
      } else {
        // const result = await getS3Object(
        //   path,
        //   undefined,
        //   "arraybuffer"
        // );
        const { url: presignedUrl } = await getPreSignedUrl(
          path,
          undefined,
          path?.split(".")?.pop(),
          "GET",
        );
        const result = await axiosPublic.default.get(presignedUrl, {
          responseType: "arraybuffer",
        });

        // const uint8Array = await streamToUint8Array(result);
        const blob = new Blob([result.data], { type: "video/mp4" });

        url = URL.createObjectURL(blob);
      }

      return url;
    } catch (error) {
      console.error("Error fetching Video data:", error);
    }
  };

  const viewTest = (testData) => {
    Alert.setTakeMcqAndDesTest(true);
    Alert.setShowBreadCrumbsData((prev) => ({
      ...prev,
      learnerid: testData.learnerid
        ? testData.learnerid
        : getDataFromStorage("learnerid"),
      status: constants.QUESTION_STATUS.SUBMITTED,
      testMode: constants.MODE.TEST_MODE,
      mockUse: true,
      lmtid: testData.lmtid,
      lmpid: testData.lmpid,
      type:testData?.testtype ?? Alert.testData.testtype
    }));
    
    const status = testData.status ?? Alert.status;
    const withAI = testData.withAI ?? Alert.testData.withAI;
    console.log("status:",status);
    
    if (
      status === constants.PROGRESS_STATUS.EVALUATED ||
      status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
      status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED
    ) {
      Alert.setMcqAndDesTestAndLpId({
        lpid: Alert.lpId,
        status: status,
        testid: testData?.testid ?? Alert.testData.testid,
        cellobj: testData?.libtype ?? Alert.testData.libtype,
        autoEval: testData?.autoeval ?? Alert.testData.autoeval,
        testmode: testData?.testmode ?? Alert.testData.testmode,
        viewTest: testData?.viewtest ?? Alert.testData.viewtest,
        libtypeid: testData?.testtype ?? Alert.testData.testtype,
        proctored: testData?.proctored ?? Alert.testData.proctored,
        configdata: testData?.configdata ?? Alert.testData.configdata,
        lpconfigid: testData?.lpconfigid ?? Alert.testData.lpconfigid,
        learnerid: testData.learnerid
          ? testData.learnerid
          : getDataFromStorage("learnerid"),
      });

      if (Alert.hasRendered.current === false) {
        Alert.hasRendered.current = true;        
        Alert.setButtonDisable(true);
        Alert.setIsLoaded(true);
        axios
          .post(
            "node/learner/course/test/report",
            JSON.stringify({
              lpid: Alert.lpId,
              lmpid: testData?.lmpid ?? Alert.testData.lmpid,
              testid: testData?.testid ?? Alert.testData.testid,
              mockuse: testData?.mockuse ?? Alert.testData.mockuse,
              libtypeid: testData?.testtype ?? Alert.testData.testtype,
              lpconfigid: testData?.lpconfigid ?? Alert.testData.lpconfigid,
              mocklp: localStorage.getItem("mockLp"),
              learnerid: testData.learnerid
                ? testData.learnerid
                : getDataFromStorage("learnerid"),
            }),
            getHeaderDetailsForAxios(),
          )
          .then((res) => {
            Alert.setButtonDisable(false);
            Alert.hasRendered.current = false;
            Alert.backupTestDataq.current = res.data.data;
            res.data.data.mockuse = Alert.testData.mockuse;

            (async () => {
              try {
                if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
                  Alert.setShowNotify({
                    show: true,
                    title: "Info",
                    msg: res.data.message,
                  });
                } else {
                  tempReport = res.data.data;

                  if (tempReport.videoqn === 1) {
                    handleVideoQuestions(tempReport.sections);
                  }

                  if (withAI) {
                    Alert.navigate("/ainterview");
                  } else {
                    Alert.navigate("/mcq");
                  }

                  calcStats(tempReport, ["all"]);
                  Alert.setTestMode(res.data.data.testmode);
                  Alert.setApiLoaded(true);
                  Alert.backupTestDataq.current = res.data.data;
                  Alert.setDescScores(tempScoresObj);
                  Alert.setBackupTestData(res.data.data);
                  Alert.setMcqTestData(res.data.data);
                  Alert.updateComingObj(res.data.data);
                  Alert.updateQuestionContainerSingle(false);
                  clearInterval(Alert.interval.current);
                  Alert.setTestPageShow(true);

                  for (let i = 0; i < res.data.data.sections.length; i++) {
                    for (
                      let j = 0;
                      j < res.data.data.sections[i].questions.length;
                      j++
                    ) {
                      if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
                        let question = res.data.data.sections[i].questions[j];

                        if (getDataFromStorage("role") === "learner") {
                          question.review = -1;
                        }

                        for (let k = 0; k < question.links.length; k++) {
                          let linkRes = await getPreSignedUrl(
                            question.links[k].link,
                            undefined,
                            question.links[k].link?.split(".")?.pop(),
                            "GET",
                          );

                          question.links[k].link = linkRes.url;
                        }

                        // if (tempReport.videoqn === 1) {
                        //   if (
                        //     res.data.data.sections[i].questions[j].answer !==
                        //       "" &&
                        //     res.data.data.sections[i].questions[j].answer !=
                        //       null
                        //   ) {
                        //     let videoRes = await fetchVideoData(
                        //       res.data.data.sections[i].questions[j].answer
                        //     );
                            
                        //     res.data.data.sections[i].questions[j].answer =
                        //       videoRes;
                        //     Alert.updateComingObj(res.data.data);
                        //   }
                        // }
                      }
                      if (
                        res.data.data.sections.length - 1 === i &&
                        res.data.data.sections[i].questions.length - 1 === j
                      ) {
                        Alert.setIsLoaded(false);
                        if (tempReport.videoqn === 1)
                          Alert.setTestPageShowReload(
                            (prevState) => !prevState,
                          );
                      }
                    }
                  }
                }
              } catch (err) {
                getCatchBlockDetails(err);
              } finally {
                Alert.setIsLoaded(false);
              }
            })();
          })
          .catch((error) => {
            getCatchBlockDetails(error);
          })
          .finally(() => Alert.setIsLoaded(false));
      }
    }
  };

  /* qn navigate */
  const scrollToQuestion = (index) => {
    if (StudentTestPageCxt.questionRefs.current[index]) {
      StudentTestPageCxt.questionRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return {
    viewTest,
    startTest,
    resetTest,
    questionUpdate,
    getSectionTotal,
    scrollToQuestion,
    preventCopyAndCut,
    handleScoreKeyDown,
    handleVideoQuestions,
    checkIfObjectExistsInArray,
  };
}
